import { render, staticRenderFns } from "./set-split.vue?vue&type=template&id=4388e29d&scoped=true"
import script from "./set-split.vue?vue&type=script&lang=js"
export * from "./set-split.vue?vue&type=script&lang=js"
import style0 from "./set-split.vue?vue&type=style&index=0&id=4388e29d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4388e29d",
  null
  
)

export default component.exports